import { IConfiguration } from "@/interfaces/local";
import { ajaxCall, ICancellableResult } from "@/tools/axios-wrapper";
import { localApi } from "./local-api";

interface IApis {
  declaration: string;
  referential: string;
}

export default class BaseApi<ObjectType, PostPayload = ObjectType, PostResponse = ObjectType> {
  protected objectName: string;
  protected apiUrl: string = "";
  private _api: keyof IApis;

  constructor(endpointName: string, api: keyof IApis = "declaration") {
    this.objectName = endpointName;
    this._api = api;
  }

  async get(): Promise<ICancellableResult<ObjectType[]>> {
    this.verifyInit();
    return await ajaxCall.get(this.apiUrl, { urlParameter: [this.objectName] });
  }
  async getById(id: string): Promise<ICancellableResult<ObjectType>> {
    this.verifyInit();
    return await ajaxCall.get(this.apiUrl, { urlParameter: [this.objectName, id] });
  }
  async add(payload: PostPayload): Promise<ICancellableResult<PostResponse>> {
    this.verifyInit();
    return await ajaxCall.post<PostResponse, PostPayload>(this.apiUrl, { urlParameter: [this.objectName], payload });
  }
  async update(payload: ObjectType): Promise<ICancellableResult<ObjectType>> {
    this.verifyInit();
    return await ajaxCall.patch<ObjectType, ObjectType>(this.apiUrl, { urlParameter: [this.objectName], payload });
  }
  async remove(id: string): Promise<ICancellableResult<void>> {
    this.verifyInit();
    return await ajaxCall.delete(this.apiUrl, { urlParameter: [this.objectName, id] });
  }

  async init() {
    if (this.apiUrl === "") {
      const config = await localApi.getLocalConfiguration();
      this.apiUrl = this._getApiUrl(config);
    }
  }

  protected verifyInit() {
    if (!this.apiUrl) {
      throw "Api " + this.objectName + " is not init. Please invoke his init function.";
    }
  }

  private _getApiUrl(config: IConfiguration): string {
    return config.api.asi;
  }
}
